import { axios } from '..'

const updateVisibilityPermissionGroupManual = (
  automationGroupManualId: string
) => {
  return axios.put(
    `/v1/automation-groups-manual/${automationGroupManualId}/send-only`
  )
}
export default updateVisibilityPermissionGroupManual
